import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Box, Grid, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import Header from "./Header";
import aboutUs from "../../Icons/Branding/aboutUs4.png";
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    minWidth: "900px",
    minHeight: "400px",
    objectFit: "cover",
  },
  marginText: {
    marginTop: "-10px !important",
  },
  subtitleColor: {
    color: theme.palette.text.primary,
  },
  divider: {
    width: "350px",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const About = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box className={classes.root} mt={5}>
      <Header title="About" />
      <Typography
        variant="h4"
        gutterBottom
        className={classes.marginText}
        align="center"
      >
        {t("pages.about.title")}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={12}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <img src={aboutUs} alt="about us" className={classes.image} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            variant="h4"
            className={classes.subtitleColor}
            gutterBottom
            ml={2}
            align="center"
          >
            Η Κοτογωνιά:
          </Typography>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Divider className={classes.divider} />
          </Box>
          <Typography
            variant="h6"
            gutterBottom
            ml={2}
            mb={6}
            textAlign="center"
          >
            Στην "Κοτογωνιά" αφιερωνόμαστε στην παροχή των πιο φρέσκων και
            νόστιμων κοτόπουλων και παρασκευών από κοτόπουλο στην περιοχή της
            Ευκαρπίας. Με την ποικιλία των προϊόντων μας, την ποιότητα
            προσπαθούμε να γίνουμε η προτιμώμενη επιλογή για όσους αναζητούν
            υψηλής ποιότητας κοτόπουλο και προϊόντα που συνοδεύουν ιδανικά το
            γεύμα.
          </Typography>
          <Typography
            variant="h4"
            className={classes.subtitleColor}
            gutterBottom
            ml={2}
            align="center"
          >
            Τα προιόντα μας:
          </Typography>
          <Divider />
          <Typography
            variant="h6"
            gutterBottom
            ml={2}
            textAlign="center"
            mb={6}
          >
            Στην "Κοτογωνιά" δίνουμε ιδιαίτερη έμφαση στην ποιότητα του
            κοτόπουλου. Συνεργαζόμαστε με τους καλύτερους προμηθευτές,
            πραγματοποιώντας προσεκτική επιλογή ώστε να εξασφαλίσουμε ότι
            προσφέρουμε μόνο τα καλύτερα προϊόντα στους πελάτες μας. Τα
            κοτόπουλα μας είναι φρέσκα, υγιεινά και προέρχονται από αξιόπιστες
            πηγές. Με τον επαγγελματισμό και την προσοχή μας στη λεπτομέρεια,
            εξασφαλίζουμε ότι κάθε κομμάτι κοτόπουλου που φεύγει από το
            κρεοπωλείο μας είναι προσεκτικά επεξεργασμένο και έτοιμο να
            απολαύσετε στο σπίτι σας. Εκτός από τα φρέσκα κοτόπουλα, προσφέρουμε
            επίσης μια ποικιλία από χειροποίητα παραδοσιακά προϊόντα. Από
            χειροποίητες λιχουδιές και οσπριά μέχρι ζυμαρικά και άλλες
            νοστιμιές, θα βρείτε ό,τι χρειάζεστε για να πλαισιώσετε το γεύμα σας
            με γεύσεις που αναδεικνύουν την παράδοση και την αυθεντικότητα.
          </Typography>
          <Typography
            variant="h4"
            className={classes.subtitleColor}
            gutterBottom
            ml={2}
            align="center"
          >
            O στόχος μας
          </Typography>
          <Divider />
          <Typography variant="h6" gutterBottom ml={2} textAlign="center">
            Ο στόχος μας στην "Κοτογωνιά" είναι να προσφέρουμε στους πελάτες μας
            μια αξέχαστη γαστρονομική εμπειρία μέσω της παροχής υψηλής ποιότητας
            κοτόπουλου και παραδοσιακών προϊόντων. Θέλουμε να γίνουμε ο
            προορισμός της επιλογής για όσους αναζητούν φρεσκάδα, γεύση και
            αυθεντικότητα σε κάθε μπουκιά. Με προσοχή στη λεπτομέρεια και
            προσήλωση στις υψηλές προδιαγραφές, διασφαλίζουμε ότι κάθε προϊόν
            που φεύγει από το κρεοπωλείο μας ανταποκρίνεται στις προσδοκίες των
            πελατών μας. Ο στόχος μας είναι να κερδίσουμε την εμπιστοσύνη και
            την ευχαρίστηση κάθε πελάτη μας, προσφέροντας προϊόντα που
            ξεχωρίζουν σε ποιότητα, γεύση και αυθεντικότητα.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default About;
